import PendingTournamentButton from "./PendingTournamentButton.jsx";
import ProgressTournamentButton from "./ProgressTournamentButton.jsx";
import FinishedTournamentButton from "./FinishedTournamentButton.jsx";
import CanceledTournamentButton from "./CanceledTournamentButton.jsx";

const combinedTournamentButtons = {
    PENDING: PendingTournamentButton,
    PROGRESS: ProgressTournamentButton,
    CANCELED: CanceledTournamentButton,
    FINISHED: FinishedTournamentButton,
}
export default combinedTournamentButtons